module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-1600.16d84a55.svg";